"use strict";

exports.__esModule = true;
exports.useSelectionContextRowSelection = useSelectionContextRowSelection;
var _react = _interopRequireWildcard(require("react"));
var _SelectionContext = require("../SelectionContext");
var _useRowSelection2 = require("./useRowSelection");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useSelectionContextRowSelection(props) {
  var componentPath = props.componentPath;
  var _React$useContext = _react["default"].useContext(_SelectionContext.SelectionContext),
    selectorPath = _React$useContext.selectorPath,
    resetSelection = _React$useContext.resetSelection;
  var _useRowSelection = (0, _useRowSelection2.useRowSelection)(),
    selectedRowIndex = _useRowSelection.selectedRowIndex,
    setSelectedRowIndex = _useRowSelection.setSelectedRowIndex,
    resetSelectedRow = _useRowSelection.resetSelectedRowIndex;

  // If the component that changes the selection context is not this component, unselect the selected row
  (0, _react.useEffect)(function () {
    if (selectorPath && componentPath !== selectorPath) {
      resetSelectedRow();
    }
  }, [selectorPath, componentPath]);

  // If the existing selection context is from this component, it means that the selection context should be reset.
  // But, if the selection context is set from some other component, then it should not be touched
  function resetSelectedRowIndex() {
    if (componentPath === selectorPath) {
      resetSelection();
    }
    resetSelectedRow();
  }
  return {
    selectedRowIndex: selectedRowIndex,
    setSelectedRowIndex: setSelectedRowIndex,
    resetSelectedRowIndex: resetSelectedRowIndex
  };
}